var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDietaryVg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#585C60",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.472 21L6.07 11.2H7.834L10.438 19.054L13.056 11.2H14.806L11.404 21H9.472ZM25.2632 15.932V16.604C25.2632 19.278 23.3312 21.182 20.4612 21.182C17.4092 21.182 15.2392 18.914 15.2392 16.1C15.2392 13.286 17.4372 11.018 20.3772 11.018C22.2392 11.018 23.8212 11.956 24.6472 13.342L23.2612 14.14C22.7572 13.23 21.6652 12.586 20.3772 12.586C18.3052 12.586 16.8492 14.112 16.8492 16.114C16.8492 18.088 18.2772 19.614 20.4752 19.614C22.2532 19.614 23.3452 18.69 23.6392 17.374H20.3632V15.932H25.2632Z",
    fill: "#585C60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDietaryVg);
export default __webpack_public_path__ + "static/media/dietary-vg.7cce8ee9283be47c5b82261ff09e4ed3.svg";
export { ForwardRef as ReactComponent };